
import mixins from "vue-typed-mixins";
import CustomValidation from "../../mixins/CustomValidation";
import { mapGetters } from "vuex";
import { object } from "yup";
import swal from "sweetalert";
import QuestWrapperComponent from "../../components/QuestWrapperComponent.vue";
import { AffiliateSubscription } from "@/interfaces/AffiliateSubscription";
import store from "@/store";
import { BIcon } from "bootstrap-vue";
import { QuestViewModel } from "@/interfaces/QuestViewModel";
import { PropType } from "vue";
import { QuestionnaireViewModel } from "@/interfaces/QuestionnaireViewModel";

export default mixins(CustomValidation).extend({
  mixins: [CustomValidation],
  name: "choosemarketplacesubscription",
  props: {
    q: Object as PropType<QuestViewModel>,
    isRefill: { type: Boolean, default: false },
    isPayment: { type: Boolean, default: false },
  },
  data() {
    return {
      schema: object().shape({
        selectedSubscription: object().nullable().required("Please select a subscription plan to continue."),
      }),
      affiliateSubscriptions: [] as AffiliateSubscription[],
      selectedSubscription: null as AffiliateSubscription | null,
      isMonthly: true,
    };
  },
  created() {
    this.getMarketplaceAffiliateSubscriptions();
    this.setupValidation(this.schema);
  },
  watch: {
    q(newVal: QuestViewModel) {
      this.importData(newVal.quest);
    },
  },
  computed: {
    ...mapGetters({
      Content: "getContent",
      QuestionnaireTypeProducts: "getQuestionnaireTypeProducts",
      Affiliate: "getAffiliate",
    }),
    sortedAffiliateSubscriptions(): AffiliateSubscription[] {
      const list = (this as any).affiliateSubscriptions as AffiliateSubscription[] | null;
      if (!list) return [];
      return list.filter((sub) => !sub.isLegacy).sort((a, b) => a.displayOrder - b.displayOrder);
    },
    getPrice() {
      return (subscription: AffiliateSubscription) => (this.isMonthly ? subscription.monthlyPrice : subscription.yearlyPrice);
    },
    getPriceText() {
      return this.isMonthly ? "/ month" : "/ year";
    },
  },
  methods: {
    importData(newVal: QuestionnaireViewModel) {
      if (!newVal) return;
      const questSub = newVal.qAffiliateSubscription;
      if (!questSub) return;
      const subscription = this.affiliateSubscriptions.find((s) => s.id === questSub.affiliateSubscriptionID);
      if (subscription) {
        this.selectedSubscription = subscription;
        this.isMonthly = questSub.subscriptionFrequencyDays === 30;
      }
    },
    async getMarketplaceAffiliateSubscriptions() {
      const result = await store.dispatch("GetMarketplaceAffiliateSubscriptions");
      if (result && result.success) {
        this.affiliateSubscriptions = result.data;
        this.importData(this.q.quest);
      } else {
        swal("Error", "Error getting subscription details. Please try again.");
      }
    },
    next_click() {
      this.errors = [];
      this.schema
        .validate({ selectedSubscription: this.selectedSubscription }, { abortEarly: false })
        .then(() => {
          this.errors = [];
          this.$emit("saveandnavigate", "+", this.getUpdatedData());
        })
        .catch((err: { inner: any[] }) => {
          err.inner.forEach((error: { path: string; message: string }): void => {
            this.errors.push({ key: error.path, value: error.message });
          });
          swal("Error", "Please select a subscription plan to continue.");
        });
    },
    prev_click() {
      this.$emit("saveandnavigate", "-", this.getUpdatedData());
    },
    selectSubscription(subscription: AffiliateSubscription) {
      this.selectedSubscription = subscription;
      this.$nextTick(() => this.next_click());
    },
    safeIncludes(s: any) {
      try {
        const raw = s && s.subscriptionIncludesJSON;
        const data = typeof raw === "string" ? JSON.parse(raw) : raw;
        return Array.isArray(data) ? data : [];
      } catch {
        return [];
      }
    },
    getUpdatedData() {
      var q = Object.assign({}, this.q.quest);
      if (this.selectedSubscription) {
        q.qAffiliateSubscription = {
          questionnaireID: q.id,
          affiliateSubscriptionID: this.selectedSubscription.id,
          subscriptionFrequencyDays: this.isMonthly ? 30 : 365,
          active: true,
        };
      }
      return q;
    },
  },
  components: {
    QuestWrapperComponent,
    BIcon,
  },
});
